import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServiceCards from './components/ServiceCards';
import About from './components/About';
import Hours from './components/Hours';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import PartiesEvents from './components/PartiesEvents';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';
import AdminHome from './components/AdminHome';
import AdminSocialMedia from './components/AdminSocialMedia';
import AdminMarketing from './components/AdminMarketing';
import AnnouncementBanner from './components/AnnouncementBanner';
import FloatingPromo from './components/FloatingPromo';
import PromoSection from './components/PromoSection';

function HomePage() {
  return (
    <>
      <Helmet>
        <title>SkyLanes Bowling Center — Poconos Premier Bowling</title>
        <meta name="description" content="SkyLanes Bowling Center in East Stroudsburg, PA — family-friendly bowling, Rock & Roll nights, parties, corporate events, leagues, and arcade fun in the Poconos." />
        <link rel="canonical" href="https://skylanesbowling.com/" />
      </Helmet>
      <Hero />
      <PromoSection />
      <ServiceCards />
      <About />
      <Hours />
      <Testimonials />
      <CTA />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/admin/login" element={
            <>
              <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <title>Admin Login — SkyLanes</title>
              </Helmet>
              <AdminLogin />
            </>
          } />
          <Route path="/admin/home" element={
            <>
              <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <title>Admin Dashboard — SkyLanes</title>
              </Helmet>
              <AdminHome />
            </>
          } />
          <Route path="/admin/social" element={
            <>
              <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <title>Social Media Manager — SkyLanes</title>
              </Helmet>
              <AdminSocialMedia />
            </>
          } />
          <Route path="/admin/marketing" element={
            <>
              <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <title>Marketing Manager — SkyLanes</title>
              </Helmet>
              <AdminMarketing />
            </>
          } />
          <Route path="/admin" element={
            <>
              <Helmet>
                <meta name="robots" content="noindex, nofollow" />
                <title>Schedule Manager — SkyLanes</title>
              </Helmet>
              <AdminPanel />
            </>
          } />
          <Route path="*" element={
            <>
              <AnnouncementBanner />
              <FloatingPromo />
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/parties-events" element={<PartiesEvents />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
